module.exports = __webpack_public_path__ + "static/media/A_iko_2_PL.7576d256.svg";